import axios from 'axios';
import React, { Component } from 'react';
import cookie from 'react-cookies'
import $ from 'jquery'

import FeedbackSurvey from './Feedback';
import GuestSurvey from './Guest';

import Loading from '../misc/Loading';
import Error from '../misc/Error';
import Thanks from '../misc/Thanks';
import Lost from '../misc/Lost';
import './styles.css';

import runtimeEnv from '@mars/heroku-js-runtime-env';
const env = runtimeEnv();

var API_BASE = env.REACT_APP_API_URL;

const SUBMITTING = 'SUBMITTING';
const SUBMITTED = 'SUBMITTED';
const SUBMIT_ERROR = 'SUBMIT_ERROR';

export default class SurveyIndex extends Component {
  constructor(props) {
    super(props);

    const { hotel, feedback_survey, guest_survey } = this.props;
    this.state = {
      hotel_id: hotel.slug,
      hotel_name: hotel.name,
      feedbackSurvey: feedback_survey,
      guestSurvey: guest_survey,
      visit: null,
      guest: null,
      error: null,
      surveyResponse: null,
      guestSurveySubmit: null,
      showSkip: false,
      logo_url: hotel.wifi_welcome_settings.logo_url,
      survey_exit_url: hotel.wifi_welcome_settings.survey_exit_url,
      theme_color: hotel.wifi_welcome_settings.color,
      show_skip_button: hotel.wifi_welcome_settings.show_skip_button,
      igd: this.getParams()
    };

    if (this.state.igd && this.state.igd.terms) {
      this.markTerms();
    }

    this.handleClick = this.handleClick.bind(this);
    this.onGuestSurveySubmit = this.onGuestSurveySubmit.bind(this);
    this.onFeedbackSurveySubmit = this.onFeedbackSurveySubmit.bind(this);
  }

  markTerms()  {
    this.state.guestSurvey.pages[0].elements.findIndex(function(element) {
      if(element.name == 'Terms'){
        element.isRequired = false;
      }
    });
  }

  getParams() {
    let params = {};
    window.location.search.substr(1).split("&").forEach(function (param_set) {
      if(param_set.split("=")[0])
        params[param_set.split("=")[0]] = unescape(param_set.split("=")[1]);
    });
    return params;
  }

  componentDidMount() {

    this.loadIGD();

    if(typeof this.state.igd != "undefined" && this.state.igd.submit == "true")
      $('[class*=complete_btn]')[0].click();

    if(typeof this.state.igd != "undefined" && this.state.igd.terms == "true")
      $('[aria-label*=terms]').prop('checked', true);

    $(".sv_complete_btn").css({"background-color": this.state.theme_color})
    if(this.state.show_skip_button == "true") {
      $('.panel-footer').append('<a type="button" class="btn btn-primary skip_button" style="background-color: '+this.state.theme_color+'" href="'+ this.state.survey_exit_url +'">Skip</a>')
    }
  }

  onGuestSurveySubmit(data) {
    this.setState({ guestSurveySubmit: SUBMITTING });
    const { name, email, mobile_number, room_number } = data;

    const params = {
      hotel_id: this.state.hotel_id,
      room_number: room_number,
      guest: {
        name: name,
        email_address: email,
        mobile_number: mobile_number
      }
    };

    axios
      .post(`${API_BASE}/visits.json`, params)
      .then((resp) => {
        // const { guest, response, visit } = resp.data;
        // removing response from version 1.0
        const { guest, visit } = resp.data;
        this.setIGD(data);

        this.setState({
          guest,
          visit: visit,
          guestSurveySubmit: SUBMITTED,
          already_defined: false
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  onFeedbackSurveySubmit(data) {
    this.setState({ feedbackSurveySubmit: SUBMITTING });

    const { hotel_id, guest, visit } = this.state;
    const params = {
      hotel_id: hotel_id,
      guest_id: guest.id,
      visit_id: visit.id,
      survey_response: data
    };

    axios
      .post(`${API_BASE}/survey_responses.json`, params)
      .then((resp) => {
        const { survey_response } = resp.data;
        this.setState({
          surveyResponse: survey_response,
          feedbackSurveySubmit: SUBMITTED
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  setIGD(data) {
    const expires = new Date();
    expires.setDate(expires.getDate() + 5);
    cookie.save('igd', data, { path: '/', expires });

    this.setState({
      igd: data
    });

    return data;
  }

  loadIGD() {
    const igd = cookie.load('igd');

    if(igd && !this.state.igd) {
      this.setState({
        igd,
        showSkip: true
      });
    }

    return igd;
  }

  currentStep() {
    const {
      feedbackSurvey,
      guestSurvey,
      visit,
      guest,
      error,
      surveyResponse,
      guestSurveySubmit,
      feedbackSurveySubmit,
      already_defined,
      survey_exit_url
    } = this.state;

    if (!(feedbackSurvey || guestSurvey || visit || guest || error || surveyResponse)) {
      return 'INITIAL';
    }

    if (guestSurveySubmit == SUBMITTING || feedbackSurveySubmit == SUBMITTING) {
      return 'LOADING';
    }

    if (guestSurvey && !guestSurveySubmit) {
      return 'IGD';
    }

    // To omit the Feedback Page we temporary disable Feedback Survey, add guestSurveySubmit with || condition
    if(guestSurveySubmit || surveyResponse) {
      if(survey_exit_url) {
        window.location.replace(survey_exit_url);
      }
      return 'THANKS';
    }

    // To omit the Feedback Page we temporary disable Feedback Survey, add guestSurveySubmit with || condition
    if(guestSurveySubmit || already_defined){
      if(survey_exit_url) {
        window.location.replace(survey_exit_url);
      }
      return 'THANKS';
    }

    if (feedbackSurvey && guestSurveySubmit == SUBMITTED) {
      return 'FEEDBACK';
    }
  }

  handleClick() {
    this.onGuestSurveySubmit(this.state.igd);
  }

  renderContent() {
    switch(this.currentStep()) {
      case 'INITIAL':
        return <Loading />;

      case 'LOADING':
        return <Loading />;

      case 'IGD':
        return (
            <div>
              <GuestSurvey json={this.state.guestSurvey} data={this.state.igd} onComplete={this.onGuestSurveySubmit} hotelName={this.state.hotel_name} />
              <div className="skip_step">
                {this.state.showSkip && <a href="javascript:void(0)" onClick={this.handleClick}> Skip this step </a>}
              </div>
            </div>
          );

      case 'FEEDBACK':
        return <FeedbackSurvey json={this.state.feedbackSurvey} data={this.state.igd} onComplete={this.onFeedbackSurveySubmit} />

      case 'ERROR':
        return <Error details={this.state.error} />

      case 'THANKS':
        return <Thanks hotelLogo={this.state.logo_url}/>;

      default:
        return <Lost />;
    }
  }

  render() {
    return (
        this.renderContent()
    );
  }
}
